import { action, makeObservable, observable } from 'mobx';
import { AnalyticsStructureService } from 'core/services/api/analytics-structure';

export const AnalyticsHelper = {
  buildTags(data: any, name = null) {
    return {
      'data-component-name': name ?? data['component_name'],
      'data-component-info': JSON.stringify(data),
    };
  },
};

export const AnalyticsStructureStore = {
  components: {} as any,
  properties: {} as any,
  isInitialized: false,
  hasStructureDataLoaded: false,

  initialize: () => {
    if (AnalyticsStructureStore.isInitialized) {
      return Promise.resolve(AnalyticsStructureStore);
    }

    AnalyticsStructureStore.isInitialized = true;

    makeObservable(AnalyticsStructureStore, {
      components: observable,
      properties: observable,
      hasStructureDataLoaded: observable,
      updateProperty: action,
      updateProperties: action,
    });

    return AnalyticsStructureService.getAnalyticsStructure().then((x) => {
      AnalyticsStructureStore.components = x.components;
      AnalyticsStructureStore.properties = x.defaultPropertyValues;
      AnalyticsStructureStore.hasStructureDataLoaded = true;

      return AnalyticsStructureStore;
    });
  },

  updateProperty: (property: string, value: string): void => {
    AnalyticsStructureStore.properties[property] = value;
  },

  updateProperties: (properties: any): void => {
    AnalyticsStructureStore.properties = { ...AnalyticsStructureStore.properties, ...properties };
  },

  getComponentAnalyticsAsJson: (componentName: string, overWriteKeys?: any): any => {
    if (!AnalyticsStructureStore.components) {
      return;
    }

    const component = AnalyticsStructureStore.components[componentName];

    if (!component) {
      return;
    }

    const componentAnalyticsStructure = AnalyticsStructureStore.getPrependedInheritedComponentStructure(component);

    return AnalyticsStructureStore.getPopulatedAnalyticsStructure(componentAnalyticsStructure, overWriteKeys);
  },

  getPrependedInheritedComponentStructure: (componentReference: any): any => {
    const component = { ...componentReference };
    const inheritedComponentName = component._inherits;

    if (!inheritedComponentName) {
      return component;
    }

    delete component._inherits;

    const inheritedComponent = AnalyticsStructureStore.components[inheritedComponentName];
    const inheritedComponentStructure =
      AnalyticsStructureStore.getPrependedInheritedComponentStructure(inheritedComponent);

    return { ...inheritedComponentStructure, ...component };
  },

  getPopulatedAnalyticsStructure: (componentAnalyticsStructure: any, overWriteKeys?: any): any => {
    Object.keys(componentAnalyticsStructure).forEach((key) => {
      const fieldValue = componentAnalyticsStructure[key];

      if (typeof fieldValue !== 'string' || !fieldValue.includes('[')) {
        return;
      }

      const properties = fieldValue.match(/\[[^\]]*\]/g);

      properties?.forEach((property) => {
        let propValue: any;

        const propertyName = property.replace('[', '').replace(']', '');
        if (overWriteKeys) {
          Object.keys(overWriteKeys).forEach((key) => {
            if (propertyName === key) {
              propValue = overWriteKeys[key];
            }
          });
        }
        const propertyValue = propValue || AnalyticsStructureStore.properties[propertyName];
        if (propertyValue) {
          componentAnalyticsStructure[key] = componentAnalyticsStructure[key].replace(
            property,
            propertyValue.replaceAll(' ', '_')
          );
        }
      });
    });

    return componentAnalyticsStructure;
  },
};